var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 2.66667H6.3335L4.66683 4.66667H2.66683C2.31321 4.66667 1.97407 4.80715 1.72402 5.0572C1.47397 5.30724 1.3335 5.64638 1.3335 6.00001V12C1.3335 12.3536 1.47397 12.6928 1.72402 12.9428C1.97407 13.1929 2.31321 13.3333 2.66683 13.3333H13.3335C13.6871 13.3333 14.0263 13.1929 14.2763 12.9428C14.5264 12.6928 14.6668 12.3536 14.6668 12V6.00001C14.6668 5.64638 14.5264 5.30724 14.2763 5.0572C14.0263 4.80715 13.6871 4.66667 13.3335 4.66667H11.3335L9.66683 2.66667Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 10.6667C9.10473 10.6667 10.0002 9.77124 10.0002 8.66667C10.0002 7.5621 9.10473 6.66667 8.00016 6.66667C6.89559 6.66667 6.00016 7.5621 6.00016 8.66667C6.00016 9.77124 6.89559 10.6667 8.00016 10.6667Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9e9114992dba4fe7cd81fb3b5cd5d4b3.svg";
export { ForwardRef as ReactComponent };